// extracted by mini-css-extract-plugin
export default {"progressContainer":"styles_progressContainer__d2-XL","progressBar":"styles_progressBar__3QvpY"};